const SIZES = { s: 24, m: 36, l: 44 };

export function Spinner({ size = "m", className = "" }) {
  const px = SIZES[size] || SIZES.m;
  return (
    <svg
      className={`ui-spinner ${className}`}
      width={px}
      height={px}
      viewBox="0 0 40 40"
      fill="none"
      role="status"
    >
      <circle
        cx="20"
        cy="20"
        r="17"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray="80 27"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 20 20"
          to="360 20 20"
          dur="0.8s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
}
